// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"styles_imgContainer__5AEQU"};